export const informationLink = "https://www.smartiscity.gr";
export const informationLinkEN = "https://www.smartiscity.gr";

export const welcomeMessageContent = [
  "Ο Δήμος Σιθωνίας σας καλωσορίζει στην Πλατφόρμα Εξυπνης Πόλης.",
  "Ενημερωθείτε για τις συνθήκες που επικρατούν στην πόλη μας.",
];
export const androidAppLink =
  "https://play.google.com/store/apps/details?id=gr.dotsoft.smartcity.sithonia";
export const iosAppLink =
  "https://apps.apple.com/us/app/sithonia-smart-city/id6769413129";
export const baseUrl = "https://sithonia.smartiscity.gr";

export const allTypesUrl = baseUrl + "/api/api.php?func=sensortypes";
export const allSensorsUrl = baseUrl + "/api/api.php?func=allsensors";

export const UvUrl = baseUrl + "/api/api.php?func=indexes";
export const enviURL = baseUrl + "/api/api.php?func=envi";
export const meshURL = baseUrl + "/api/api.php?func=mesh";
export const meteoURL = baseUrl + "/api/api.php?func=meteo";
export const poiURL = baseUrl + "/api/api.php?func=pois";
export const fleetoUrl = baseUrl + "/api/api.php?func=fleeto";
export const binsUrl = baseUrl + "/api/api.php?func=bins";
export const hydroUrl = baseUrl + "/api/api.php?func=hydro";
export const weatherUrl = baseUrl + "/api/api.php?func=forecast";
export const wifiUrl = baseUrl + "/api/api.php?func=hotspot";
export const hamURL = baseUrl + "/api/api.php?func=ham";

export const allBinsCharts = baseUrl + "/api/api.php?func=allbinstats";
export const specificBinChart = baseUrl + "/api/api.php?func=binstats";

export const chartsUrls = baseUrl + "/api/api.php?func=stats";

export const gallerySmall = baseUrl + "/gallery/vars/Small/";
export const galleryBig = baseUrl + "/gallery/vars/Big/";

export const hotSpotParameterId = "103";

export const cityCenter = {
  lat: 40.150449,
  lng: 23.788246,
};

// settings
export const showEnvironmentAddress = true;
